<template>
  <div class="login">
    <Login/>
  </div>
</template>

<script>
  import Login from "@/components/Login.vue";

  export default {
    name: "login",
    components: {
      Login,
    }
  };
</script>

<style src='./Login.scss' lang="scss"></style>

